export default __webpack_public_path__ + "static/media/gallery_01.e8fe83fb.jpg";